import axios from "axios"

const baseUrl = `${process.env.REACT_APP_MAIN_API}/person/user/activate`
const activationFallbackMessage =
  'No fue posible activar la cuenta. Verifica que la contraseña cumpla los requisitos e intenta nuevamente.'

interface Iprops {
    token: string,
    document: string,
    birthDate: string,
    password: string,
    documentType: number,
}

// service to activate new user
export default async function index (props: Iprops) {

  const { token, document, birthDate, password, documentType} = props
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  }

    const body = {
        "document": document,
        "birth_date": birthDate,
        "password": password,
        "document_type": documentType
    }

    const res = await axios.put(baseUrl, body, { headers }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error("error active user ", error)
        return {
          ok: false,
          status: error?.response?.status,
          message: error?.response?.data?.message || activationFallbackMessage,
        };
      });
      return res

}
